import BaseAPI from '../BaseAPI';

export default class LocationAPI extends BaseAPI {
  async getOrganizationLocations({
    orgId,
    startIndex,
    count,
  }: {
    orgId: string;
    startIndex: number;
    count: number;
  }) {
    return this.httpClient.get(`${this.host.tcUrl}/v1/user-service/locations/associations`, {
      headers: {
        'tt-x-organization-key': orgId,
      },
      query: {
        startIndex: startIndex,
        count: count,
        forceFetch: 'false',
        associations: 'personas',
      },
    });
  }

  async updateLocationPersonas({
    orgId,
    locationType,
    locationId,
    associationsToAdd,
    associationsToRemove,
  }: {
    orgId: string;
    locationId: string;
    locationType: string;
    associationsToAdd: string[];
    associationsToRemove: string[];
  }) {
    return this.httpClient.put(`${this.host.tcUrl}/v1/user-service/locations/associations`, {
      headers: {
        'tt-x-organization-key': orgId,
      },
      data: {
        locationType,
        locationId,
        associationsToAdd,
        associationsToRemove,
      },
      query: {
        forceFetch: 'false',
        association: 'Personas',
      },
    });
  }

  async getUserLocations({ accountId, orgId }: { accountId: string; orgId: string }) {
    return this.httpClient.get<{ name: string; children: { name: string }[] }[]>(
      `${this.host.tcUrl}/v1/user-service/${accountId}/locations`,
      {
        headers: {
          'tt-x-organization-key': orgId,
        },
      }
    );
  }
}
